import { requestJson } from "./apiClient";

/**
 * @typedef {Object} PublicVehicleListingIdentityMetadata
 * @property {string} id - Public mobility listing ID (`vehicle_listing.id`); equals `mobilityListingId`.
 * @property {string} mobilityListingId - Explicit `vehicle_listing.id`.
 * @property {string|null} marketListingId - Linked `vehicle_market_listings.id` when one valid mapping exists.
 * @property {string|null} canonicalVehicleId - Cross-marketplace grouping id (`canonical_vehicle.id`).
 * @property {string} canonicalPublicUrl - Canonical public route using the mobility listing id.
 */

// Public vehicles API — consumed by publicVehicleListingsService (M3).
const PUBLIC_BASE = "/api/v1/views";

export async function fetchClientViewVehicles(slug, params = {}, options = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") {
      searchParams.set(key, String(value));
    }
  });
  const qs = searchParams.toString();
  return requestJson(
    `${PUBLIC_BASE}/${encodeURIComponent(slug)}/vehicles${qs ? `?${qs}` : ""}`,
    options
  );
}

export async function fetchClientViewVehicleDetail(slug, vehicleListingId, params = {}, options = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") {
      searchParams.set(key, String(value));
    }
  });
  const qs = searchParams.toString();
  return requestJson(
    `${PUBLIC_BASE}/${encodeURIComponent(slug)}/vehicles/${encodeURIComponent(vehicleListingId)}${qs ? `?${qs}` : ""}`,
    options
  );
}

export async function fetchClientViewVehicleFilters(slug, params = {}, options = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") {
      searchParams.set(key, String(value));
    }
  });
  const qs = searchParams.toString();
  return requestJson(
    `${PUBLIC_BASE}/${encodeURIComponent(slug)}/vehicles/filters${qs ? `?${qs}` : ""}`,
    options
  );
}

export async function fetchClientViewVehicleListingsBatch(slug, listingIds = [], params = {}, options = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") {
      searchParams.set(key, String(value));
    }
  });
  const qs = searchParams.toString();
  return requestJson(
    `${PUBLIC_BASE}/${encodeURIComponent(slug)}/vehicle-listings/batch${qs ? `?${qs}` : ""}`,
    {
      method: "POST",
      body: JSON.stringify({ listingIds }),
      headers: { "Content-Type": "application/json" },
      ...options,
    }
  );
}
